import styled from 'styled-components';
import { Avatar } from 'apps/components/shared';
import { media, truncateWidth } from 'legacyComponents/styled/styleUtils';

export const ProfileWrapper = styled.div`
  position: relative;
  padding: ${props => props.theme.spacing.default} 0;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const ProfileAvatar = styled(Avatar)`
  display: inline-block;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  width: 50px;
  height: 50px;
  ${media.s`
    width: 40px;
    height: 40px;
  `}
`;

export const Title = styled.h4`
  margin: 0;
  position: absolute;
  top: 24px;
  left: ${props => (props.project ? '92px' : '65px')};
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
  ${media.s`
    left: ${props => (props.project ? '92px' : '55px')};
    top: 32px;
  `}
`;

export const Bio = styled.p`
  font-size: ${props => props.theme.font.size.small};
  margin: 0;
  position: absolute;
  bottom: 30px;
  left: ${props => (props.project ? '92px' : '65px')};
  ${truncateWidth('430px')};
  padding-right: ${props => props.theme.spacing.default};
  ${media.s`
    display: none;
  `}
`;

export const ProjectImage = styled(Avatar)`
  display: inline-block;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  border-radius: 1px;
  width: 78px;
`;

export const FollowButtonWrapper = styled.div`
  position: absolute;
  top: 30px;
  right: 0px;
  ${media.s`
    top: 28px;
  `}
`;
